export function round(value: number, decimals: number): number {
    return parseInt(`${value * Math.pow(10, decimals)}`) / Math.pow(10, decimals);
}